import { BodyDefault } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const WarningHighlightName = styled(BodyDefault)`
  margin: 0;
  color: ${({ theme }) => theme.colors.BLACK_900};
  font-weight: 500;
  display: inline;
`
